exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-table .warning-row[data-v-51106f7d]{background:#fdf5e6}table[data-v-51106f7d]{border-collapse:collapse;width:100%}td[data-v-51106f7d],th[data-v-51106f7d]{border:1px solid #ddd;text-align:left;padding:8px}", ""]);

// exports
